export default __webpack_public_path__ + "static/media/IMG_5755.cc1056de.JPG";